angular.module('gym.components').directive('suspensionList', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/forms/suspension_list.html.slim'),
    scope: {
      contact: '=',
      suspensions: '=',
      form: '=',
      archive: '&'
    },
    controller: ["$scope", "$rootScope", "$state", "$modal", function($scope, $rootScope, $state, $modal) {
      var hasActiveMembership, today;
      today = $rootScope.gym.today;
      $scope.isCollapsed = true;
      $scope.pastSuspensions = function() {
        return _.filter($scope.suspensions, function(suspension) {
          return moment(suspension.end_on).isBefore(today);
        });
      };
      $scope.getSuspension = function() {
        if ($scope.isCollapsed) {
          return _.filter($scope.suspensions, function(suspension) {
            return moment(suspension.end_on).isSameOrAfter(today);
          });
        } else {
          return $scope.suspensions;
        }
      };
      hasActiveMembership = function() {
        return !!_.find($scope.contact.memberships, function(membership) {
          return membership.active;
        });
      };
      $scope.remove = function(suspension) {
        if (hasActiveMembership()) {
          return $state.go('gym.contacts.confirmRemoveSuspension', {
            contactId: $scope.contact.id,
            suspensionId: suspension.id
          });
        } else {
          return $scope.archive({
            suspension: suspension,
            form: $scope.form
          });
        }
      };
      $scope.toggleList = function() {
        return $scope.isCollapsed = !$scope.isCollapsed;
      };
      return $scope.showHistory = function(suspension) {
        return $modal.open({
          template: require('templates/components/contacts/forms/suspension_history_modal.html.slim'),
          size: 'lg',
          resolve: {
            suspension: function() {
              return suspension;
            }
          },
          controller: 'ShowSuspensionHistoryModalCtrl'
        });
      };
    }]
  };
});
